import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#040404" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Craft A Pleasing UI/UX for Your App with Our Flutter App
              Development
            </h2>
            <p>
              Enhance your app's user experience with our expert Flutter app
              development services in Dubai. As a team, we specialize in
              crafting visually stunning user interfaces that attract audiences
              to the maximum engagement. We customize every aspect of your app's
              UI/UX as per your brand image to ensure a pleasing user journey.
            </p>
            <p>
              Our Flutter app development company focuses on user-centric design
              principles and the latest industry trends. That’s how we ensure
              that your app looks great while providing exceptional
              functionality. So, let us help you create a lasting impression on
              users, resulting in an increased retention rate.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#040404",
                border: "1px solid #040404",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let’s Collaborate for Your Project!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <StaticImage
              src="../../images/location_new/fold5/craft_dubai.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={866}
              height={1042}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
